type ClassValue = string | false | null | undefined

/** Une clases descartando las vacías. Evita los `${a} ${b ? c : ''}` sueltos. */
export const cx = (...values: ClassValue[]): string => values.filter(Boolean).join(' ')
